
Vue.component("live_card", {
  props: {
      info: {
          type: Object,
          required: true,
          default: () => ({})
      }
  },
  methods: {
      handleCopy(value) {
          let oInput = document.createElement('input');
          oInput.value = value;
          document.body.appendChild(oInput);
          oInput.select(); // 选择对象
          document.execCommand("Copy"); // 执行浏览器复制命令
          message.success("复制成功");
          oInput.remove();
      }
  },
  template: `
<el-card class="live-card">
  <div slot="header" class="clearfix">
    <span class="live-tag">{{$t('直播课程信息')}}</span>
  </div>
  <div class="live-c-container">
    <p v-if="info.startTime"><span>{{$t('开课时间')}}：</span>{{info.startTime}}</p>
    <p v-if="info.useSoftware"><span>{{$t('使用软件')}}：</span>{{info.useSoftware}}</p>
    <p v-if="info.meetingNumber"><span>{{$t('会议号')}}：</span><span>{{info.meetingNumber}}<i class="el-icon-document-copy" @click="handleCopy(info.meetingNumber)"></i></span></p>
    <p v-if="info.link"><span>{{$t('链接')}}：</span><span><a :href="info.link" target="_blank">{{info.link}}</a><i class="el-icon-document-copy" @click="handleCopy(info.link)"></i></span></p>
    <p v-if="info.password"><span>{{$t('密码')}}：</span><span>{{info.password}}<i class="el-icon-document-copy" @click="handleCopy(info.password)"></i></span></p>
    <p v-if="info.remark" class="remark"><span>{{$t('备注')}}：</span><span>{{info.remark}}</p>
  </div>
  <div class='bottom-container'>
    <div class="teacher-container">
      <span>{{info.userName}}</span>
      <span>{{dateFormate(new Date(info.createDate).valueOf(), "y-m-d h:i:s")}} {{$t('编辑')}}</span>
    </div>
  </div>
</el-card>`
});